module.exports = __webpack_public_path__ + "./assets/wahoo-bfeb77.obj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wahoo.obj
// module id = 23
// module chunks = 0